import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, InputNumber, Tooltip } from "antd";
import FormItem from "components/form/FormItem";
import { useTranslation } from "react-i18next";

export default function SyncStockWarehouse() {
   const { t } = useTranslation();
   return (
      <Card title={t('mores.locations.syncStockWarehouse.title')}>
         <FormItem
            name="rationSyncStock"
            label={(
               <div className="d-flex align-items-center">
                  <div className="text-[14px] title-gray-color mr-[5px]">{t('mores.locations.syncStockWarehouse.syncStock')}</div>
                  <Tooltip title={t('mores.locations.syncStockWarehouse.syncStockDesc')}>
                     <FontAwesomeIcon icon={faCircleInfo} className="text-[14px] title-gray-color" />
                  </Tooltip>
               </div>
            )}
            initialValue={100 as number}
         >
            <InputNumber
               className="w-full"
               min={0}
               defaultValue={100 as number}
               formatter={(value) => String(parseInt((String(value || 0)), 10))}
               parser={(value) => parseInt(value, 10)}
            />
         </FormItem>
         <FormItem
            name="minStockValue"
            label={(
               <div className="d-flex align-items-center">
                  <div className="text-[14px] title-gray-color mr-[5px]">{t('mores.locations.syncStockWarehouse.minStockValue')}</div>
                  <Tooltip title={t('mores.locations.syncStockWarehouse.minStockValueDesc')}>
                     <FontAwesomeIcon icon={faCircleInfo} className="text-[14px] title-gray-color" />
                  </Tooltip>
               </div>
            )}
            initialValue={0 as number}
         >
            <InputNumber
               className="w-full"
               min={0}
               defaultValue={0 as number}
               formatter={(value) => String(parseInt((String(value || 0)), 10))}
               parser={(value) => parseInt(value, 10)}
            />
         </FormItem>
         <FormItem
            name="maxStockValue"
            label={(
               <div className="d-flex align-items-center">
                  <div className="text-[14px] title-gray-color mr-[5px]">{t('mores.locations.syncStockWarehouse.maxStockValue')}</div>
                  <Tooltip title={t('mores.locations.syncStockWarehouse.maxStockValueDesc')}>
                     <FontAwesomeIcon icon={faCircleInfo} className="text-[14px] title-gray-color" />
                  </Tooltip>
               </div>
            )}
            initialValue={-1 as number}
         >
            <InputNumber
               className="w-full"
               min={-1}
               defaultValue={-1 as number}
               formatter={(value) => String(parseInt((String(value || 0)), 10))}
               parser={(value) => parseInt(value, 10)}
            />
         </FormItem>
      </Card>
   )
}